export const UPDATE_USUARIO = 'UPDATE_USUARIO';
export const RESET_USUARIO = 'RESET_USUARIO';
export const ADD_ERRORS = 'ADD_ERRORS'